export enum roles {
  admin = 'admin',
  listener = 'listener',
  adminProgram = 'adminProgram',
}

export const rolesTranslation: { [k: string]: string } = {
  [roles.admin]: 'Администратор',
  [roles.listener]: 'Слушатель',
  [roles.adminProgram]: 'Администратор программ',
}

export const rolesBadges: { [k: string]: string } = {
  [roles.admin]: 'Адм',
  [roles.listener]: 'Слу',
  [roles.adminProgram]: 'АдмПр',
}
